<template>
  <Layout>Unavailable</Layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  computed: {
    ...mapGetters('contentful', ['contentfulLoadingStatus']),
    messageCode() {
      return this.$attrs.code || ''
    },
  },
  methods: {
    ...mapActions('payment', ['resetPaymentData']),
    ...mapActions('ui', ['setPageLoadingStatus']),
    init() {
      this.setPageLoadingStatus('loading')
      this.resetPaymentData()
      this.setPageLoadingStatus('loaded')
    },
  },
  watch: {
    contentfulLoadingStatus(newVal) {
      if (newVal === 'loaded' || newVal === 'error') {
        this.init()
      }
    },
  },
  created() {
    if (this.contentfulLoadingStatus === 'loaded') {
      this.init()
    }
  },
}
</script>

<style lang="scss" module>
@import '@design';
</style>
